import React from "react";
import { Box, InputAdornment, TextField, InfoCircleIcon } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const BasicTextFieldError = () => {
  return (
    <>
      <Box sx={{ width: "80%", marginInline: " auto", p:3 }}>
        <PreviewAndEditor
          title={"Text field in Error State"}
          language={"js"}
          value={
            "          <TextField\n" +
            "            error\n" +
            '            defaultValue={"Something wrong"}\n' +
            "            InputProps={{\n" +
            "              endAdornment: (\n" +
            '                <InputAdornment position="end">\n' +
            '                  <InfoIcon fontSize={"small"} color={"error"} />\n' +
            "                </InputAdornment>\n" +
            "              ),\n" +
            "            }}\n" +
            "          />\n\n\n" +
            "          <TextField\n" +
            "            error\n" +
            '            variant="filled"\n' +
            '            defaultValue={"Something wrong"}\n' +
            "            InputProps={{\n" +
            "              endAdornment: (\n" +
            '                <InputAdornment position="end">\n' +
            '                  <InfoIcon fontSize={"small"} color={"error"} />\n' +
            "                </InputAdornment>\n" +
            "              ),\n" +
            "            }}\n" +
            "          />\n\n\n" +
            "          <TextField\n" +
            "            error\n" +
            '            variant="standard"\n' +
            '            defaultValue={"Something wrong"}\n' +
            "            InputProps={{\n" +
            "              endAdornment: (\n" +
            '                <InputAdornment position="end">\n' +
            '                  <InfoIcon fontSize={"small"} color={"error"} />\n' +
            "                </InputAdornment>\n" +
            "              ),\n" +
            "            }}\n" +
            "          />"
          }
        >
          <TextField
            error
            defaultValue={"Something wrong"}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <InfoCircleIcon fontSize={"small"} color={"error"} />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            error
            variant="filled"
            defaultValue={"Something wrong"}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <InfoCircleIcon fontSize={"small"} color={"error"} />
                </InputAdornment>
              ),
            }}
          />
          <TextField
            error
            variant="standard"
            defaultValue={"Something wrong"}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <InfoCircleIcon fontSize={"small"} color={"error"} />
                </InputAdornment>
              ),
            }}
          />
        </PreviewAndEditor>
      </Box>
    </>
  );
};

export default BasicTextFieldError;
